<template>
  <div>
    <div class="container-fluid bg-light py-6 my-6 mt-0">
      <div class="container text-center animated bounceInDown">
        <h1 class="display-1 mb-4">{{ $t('404') }}</h1>
        <ol
          class="breadcrumb justify-content-center mb-0 animated bounceInDown"
        >
          <li class="breadcrumb-item"><a href="#">{{ $t("home") }}</a></li>
          <li class="breadcrumb-item text-dark" aria-current="page">
            {{ $t('404') }}
          </li>
        </ol>
      </div>
    </div>
    <!-- Hero End -->

    <!-- 404 Start -->
    <div class="container-fluid py-6 wow fadeInUp" data-wow-delay="0.1s">
      <div class="container text-center">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <i class="bi bi-exclamation-triangle display-1 text-primary"></i>
            <h1 class="display-1">{{ $t('404') }}</h1>
            <h1 class="mb-4">{{ $t('pageNotFound') }}</h1>
            <p class="mb-4">
                {{ $t('404Para') }}
            </p>
            <router-link to="/" class="btn btn-primary rounded-pill py-3 px-5">Go Back To Home</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 404 End -->
  </div>
</template>

<script>
export default {};
</script>

<style></style>
